import React from 'react';
import AssignmentDialog from 'src/components/project/sections/TractComponents/ProcessingAndMaintenance/AssignmentDialog';
import LeaseRecordDialog from 'src/components/project/sections/TractComponents/ProcessingAndMaintenance/LeaseRecordDialog';
import TransmittalDialog from 'src/components/project/sections/TractComponents/ProcessingAndMaintenance/TransmittalDialog';
import Assignment from 'src/models/dlcLease/Assignment';
import LeaseRecording from 'src/models/dlcLease/LeaseRecording';
import Transmittal from 'src/models/dlcLease/Transmittal';
import State from 'src/models/State';

export type dialogCreator = {
    recordLease: (leaseNumber: number, leaseRecording: LeaseRecording, sendUpdate: () => void) => void;
    assignments: (assignment: Assignment, states: State[], sendUpdate: () => void) => void;
    transmittals: (transmittal: Transmittal, sendUpdate: () => void) => void;
};

const creators = (setDialog: (element: React.ReactElement) => void): dialogCreator => {
    return {
        recordLease: (leaseNumber: number, leaseRecording: LeaseRecording, sendUpdate: () => void) => {
            setDialog(
                React.createElement(LeaseRecordDialog, {
                    leaseNumber: leaseNumber,
                    leaseRecording: leaseRecording,
                    sendUpdate
                })
            );
        },
        assignments: (assignment: Assignment, states: State[], sendUpdate: () => void) => {
            setDialog(
                React.createElement(AssignmentDialog, {
                    assignment: assignment,
                    states: states,
                    sendUpdate: sendUpdate
                })
            );
        },
        transmittals: (transmittal: Transmittal, sendUpdate: () => void) => {
            setDialog(
                React.createElement(TransmittalDialog, {
                    transmittal: transmittal,
                    sendUpdate: sendUpdate
                })
            );
        }
    };
};

export default creators;


// WEBPACK FOOTER //
// ./src/providers/dialogs/processing.ts